<template>
  <div class="order-card">
    <div :class="['order-container']">
      <div class="order-image">
        <font-awesome-icon
          :icon="['fa', 'clipboard-list']"
          class="icon-status"
        />
      </div>
      <div class="order-details">
        <div>
          <div class="detail">
            <div class="d-flex">
              <div class="icon-wrp">
                <font-awesome-icon
                  :icon="['fa', 'clipboard-list']"
                  class="icon-status"
                />
              </div>
              <div class="price font-weight-bold text-end">
                {{ con?.custom.orderSn }}
              </div>
            </div>
          </div>

          <div class="detail d-flex justify-content-between flex-wrap">
            <div class="d-flex">
              <div class="icon-wrp">
                <font-awesome-icon :icon="['fa', 'money-bill']" />
              </div>
              {{ $t("paymentAmount") }}
            </div>
            <div class="price font-weight-bold text-end">
              {{ getCurrency(con?.custom.totalAmount) }}
            </div>
          </div>
          <div class="detail d-flex justify-content-between flex-wrap">
            <div class="d-flex">
              <div class="icon-wrp">
                <font-awesome-icon :icon="['fa', 'truck']" />
              </div>
              <span class="text-end">
                {{ con?.custom.shippingCarrier }}
              </span>
            </div>
          </div>
          <!-- <span class="order-status">STATUS:{{ con.custom.orderStatus }}</span> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import getCurrencyByMode from "@/helpers/getCurrencyByMode";

export default {
  name: "ChatOrderCard",
  props: {
    con: {
      required: false,
      type: Object
    }
  },
  methods: {
    handleOpenTab(url) {
      if (url) window.open(decodeURIComponent(url), "_blank");
    },
    getCurrency(amount) {
      const MODE = process.env.VUE_APP_MODE;
      return getCurrencyByMode(amount, MODE);
    }
  }
};
</script>

<style lang="scss" scoped>
.detail {
  font-size: 12px;
  margin-bottom: 5px;
  div:first-child {
    color: #9c9c9c;
  }

  .price {
    color: #832abf;
  }

  .note {
    color: #832abf;
    // cursor: pointer;
  }

  .icon-wrp {
    width: 20px;

    svg {
      width: 13px;
      height: 13px;
    }
  }
}
.order-container {
  display: flex;
  min-height: 40px;
  background-color: #fafafa;
  border-radius: 6px;
  font-size: 14px;

  &.clickable {
    cursor: pointer;
    transition: background-color 0.2s ease;
  }

  .order-image {
    color: #832abf;
    font-size: 45px;
    display: flex;
    justify-content: center;
    align-items: middle;
    padding: 12px;
  }

  .order-details {
    flex: 1;
    padding: 5px 12px;
    display: flex;
    flex-direction: column;
    justify-content: center;

    .see-detail {
      color: #832abf;
      font-size: 10px;
    }

    .order-status {
      color: #ee4d2d;
      font-size: 10px;
      + div {
        color: #9c9c9c;
      }
    }
  }
}

/* Responsive adjustments */
@media (max-width: 480px) {
}
</style>
